/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/state-in-constructor */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Form } from 'antd';
import { Grid, TextField, Snackbar } from '@material-ui/core';
import MySnackbarContentWrapper from '../../../../components/SnackBar';
import { getFriendlyErrorMessage } from '../../../../utils/errorHelper';
import { SelectProductTypes } from '../../productTypes/components/SelectProductTypes';
import { SelectBrandsPage } from '../../brands/components/SelectBrandsPage';

class productForm extends React.Component {
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
    snackOpen: false,
    snackType: 'info',
    snackMessage: 'Action executing...',
    productTypeId: this.props.productTypeId,
    brandId: this.props.brandId,
  };

  handleClose = () => {
    this.setState({ snackOpen: false });
  };

  setStateValues = (open, type, message) => {
    this.setState({ snackOpen: open });
    this.setState({ snackType: type });
    this.setState({ snackMessage: message });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ snackOpen: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props
          .query_f({
            variables: {
              id: this.props.id,
              name: values.name,
              productTypeId: this.state.productTypeId,
              brandId: this.state.brandId,
              hotsite: values.hotsite,
              appURL: values.appURL,
              TOSLink: values.TOSLink,
              category: values.category,
              compatibility: values.compatibility,
              lastUpdated: values.lastUpdated,
              version: values.version,
            },
          })
          .then(
            () => {
              this.setStateValues(
                true,
                'success',
                'Action executed with success!',
              );
              if (this.props.onCancel) {
                this.props.onCancel();
              }
            },
            (error) => {
              this.setStateValues(
                true,
                'error',
                getFriendlyErrorMessage(error),
              );
            },
          );
      } else {
        this.setStateValues(true, 'error', 'Form validation failed!');
      }
    });
  };

  handleConfirmBlur = (e) => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  handleProductType = (e) => {
    this.setState({ productTypeId: e || this.state.productTypeId });
  };

  handleBrand = (e) => {
    this.setState({ brandId: e || this.state.brandId });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <form id="myForm2" onSubmit={this.handleSubmit}>
        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          open={this.state.snackOpen}
          autoHideDuration={6000}
          onClose={this.handleClose}
        >
          <MySnackbarContentWrapper
            onClose={this.handleClose}
            variant={this.state.snackType}
            message={this.state.snackMessage}
          />
        </Snackbar>
        <Grid container spacing={0}>
          <SelectProductTypes
            productTypeId={this.state.productTypeId}
            setProductTypeId={this.handleProductType}
          />
          <SelectBrandsPage
            brandId={this.state.brandId}
            setBrandId={this.handleBrand}
          />
          <Grid item xs={12}>
            {getFieldDecorator('name', {
              initialValue: this.props.name || '',
              rules: [{ required: true }],
            })(
              <TextField
                id="name"
                label="name"
                color="primary"
                fullWidth
                style={{ marginTop: 13 }}
                InputLabelProps={{ shrink: true }}
                placeholder=""
              />,
            )}
          </Grid>
          <Grid item xs={12}>
            {getFieldDecorator('hotsite', {
              initialValue: this.props.hotsite || '',
              rules: [{ required: false }],
            })(
              <TextField
                id="hotsite"
                label="hotsite"
                color="primary"
                fullWidth
                style={{ marginTop: 13 }}
                InputLabelProps={{ shrink: true }}
                placeholder=""
              />,
            )}
          </Grid>
          <Grid item xs={12}>
            {getFieldDecorator('appURL', {
              initialValue: this.props.appURL || '',
              rules: [{ required: false }],
            })(
              <TextField
                id="appURL"
                label="appURL"
                color="primary"
                fullWidth
                style={{ marginTop: 13 }}
                InputLabelProps={{ shrink: true }}
                placeholder=""
              />,
            )}
          </Grid>
          <Grid item xs={12}>
            {getFieldDecorator('TOSLink', {
              initialValue: this.props.TOSLink || '',
              rules: [{ required: false }],
            })(
              <TextField
                id="TOSLink"
                label="TOSLink"
                color="primary"
                fullWidth
                style={{ marginTop: 13 }}
                InputLabelProps={{ shrink: true }}
                placeholder=""
              />,
            )}
          </Grid>
          <Grid item xs={12}>
            {getFieldDecorator('category', {
              initialValue: this.props.category || '',
              rules: [{ required: false }],
            })(
              <TextField
                id="category"
                label="category"
                color="primary"
                fullWidth
                style={{ marginTop: 13 }}
                InputLabelProps={{ shrink: true }}
                placeholder=""
              />,
            )}
          </Grid>
          <Grid item xs={12}>
            {getFieldDecorator('compatibility', {
              initialValue: this.props.compatibility || '',
              rules: [{ required: false }],
            })(
              <TextField
                id="compatibility"
                label="compatibility"
                color="primary"
                fullWidth
                style={{ marginTop: 13 }}
                InputLabelProps={{ shrink: true }}
                placeholder=""
              />,
            )}
          </Grid>
          <Grid item xs={12}>
            {getFieldDecorator('lastUpdated', {
              initialValue: this.props.lastUpdated || '',
              rules: [{ required: false }],
            })(
              <TextField
                id="lastUpdated"
                label="last Updated"
                color="primary"
                fullWidth
                style={{ marginTop: 13 }}
                InputLabelProps={{ shrink: true }}
                placeholder=""
              />,
            )}
          </Grid>
          <Grid item xs={12}>
            {getFieldDecorator('version', {
              initialValue: this.props.version || '',
              rules: [{ required: false }],
            })(
              <TextField
                id="version"
                label="version"
                color="primary"
                fullWidth
                style={{ marginTop: 13 }}
                InputLabelProps={{ shrink: true }}
                placeholder=""
              />,
            )}
          </Grid>
        </Grid>
      </form>
    );
  }
}

const productsForm = Form.create()(productForm);

export default productsForm;
